import apiClient from './ApiInterceptor';

export const fetchSubscription = async (userId) => {
    const response = await apiClient.get(`/subscriptions/user/${userId}`);
    return response;
}

export const updateSubscriptionInstallments = async (subscriptionId, installments) => {
    try {
        const response = await apiClient.patch(`/subscriptions/${subscriptionId}`, { installments: installments });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('SubscriptionsApi - fetchSubscription, Error fetching subscription:', error);
        return { success: false, error };
    }
};

export const updateSubscriptionAnticipation = async (subscriptionId, days) => {
    try {
        const response = await apiClient.patch(`/subscriptions/${subscriptionId}`, { anticipation: days });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('SubscriptionsApi - fetchSubscription, Error fetching subscription:', error);
        return { success: false, error };
    }
};

export const cancelSubscription = async (subscriptionId, options = {}) => {
    const response = await apiClient.post(`/subscriptions/${subscriptionId}/cancel`, options);
    return response;
};

export const reactivateSubscription =  async (subscriptionId) => {
    const response = await apiClient.post(`/subscriptions/${subscriptionId}/reactivate`);
    return response;
};

export const tokenizeCard = async ({ token, planId = null, amountInCents = null, currency = 'COP' }) => {
    try {
        const response = await apiClient.post('/payments/tokenize-card', {
            token,
            planId,
            amountInCents,
            currency
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('SubscriptionsApi - tokenizeCard, Error tokenizing card:', error);
        return { success: false, error };
    }
};
